import React, { Component } from 'react';
import Slider from 'react-slick';
import { Loader } from "../Common/Loader";
import About from "../Common/About";
import Splash from "../Home/Splash";
import { isUserLoggedIn } from "../../actions/Common";

class UserGuide extends Component {
    /**
     * Render the user guide page
     * @returns {*}
     */
    constructor() {
        super();
        this.state = {
            iconDisplay: 'block'
        }
    }
    homeAppIcon = () => {
        this.setState({
            iconDisplay: 'none'
        })
    }
    componentWillMount() {
        if (isUserLoggedIn()) {
            window.location.assign('/dashboard');
            return false;
        }
    }
    render() {


        return (
            <div>
                <section className="film-page">
                    <Splash
                        homeAppIcon={this.homeAppIcon}
                        gotoWebAppEvent={this.gotoWebAppEvent}
                    />
                </section>
                <About />
            </div>
        );
    }
}

export default UserGuide;


// WEBPACK FOOTER //
// ./components/StaticPages/UserGuide.js